import { createAction, props } from '@ngrx/store';
import { IEmpleador } from '@shared/interfaces/app.state.interfaces';

export const empleador = createAction(
    '[Empleador] Data',
    props<{ item: IEmpleador }>()
)

export const updateEmpleador = createAction(
    '[Empleador] Update Empleador',
    props<{ changes: Partial<IEmpleador> }>()
);